export default "__VITE_ASSET__DMj3hEAd__"